import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";
import { FreeFieldPermissionProfilePreview } from "components/PreviewPanel/FreeFieldPermissionProfile/FreeFieldPermissionProfilePreviewPanel";

export const RemovableFreeFieldProfile = (props: RemovableProps<server.dto.FreeFieldProfileSmall>) => {

  return <RemovableLabel
    {...props}
  >
    <FreeFieldPermissionProfilePreview
      environment={props.value.environment}
      freeFieldPermissionProfileId={props.value.freeFieldProfileId}
      trigger={<a>
        {props.value.title}
      </a>}
    />
  </RemovableLabel>;
};